import { AbstractControl, FormControl, FormGroup } from "@angular/forms";

import _merge from "lodash/merge";
import { Observable } from "rxjs";
import { merge } from "rxjs/internal/observable/merge";
import { map } from "rxjs/operators";

import { BaseObservableForm } from "../../../../shared-library/forms/base-observable.form";

import { DirectorySearchParametersModel } from "../models/directory-search-parameters.model";

export class DirectorySearchForm extends BaseObservableForm<DirectorySearchParametersModel> {
    public static createForm(
        initialSearchParams: DirectorySearchParametersModel,
        emptySearchParams: DirectorySearchParametersModel
    ): DirectorySearchForm {
        const formGroup = new FormGroup({
            searchTab: new FormControl(initialSearchParams.searchTab),
            templateId: new FormControl(initialSearchParams.templateId),

            searchText: new FormControl(initialSearchParams.searchText),
            sortOption: new FormControl(initialSearchParams.sortOption),
            pageNumber: new FormControl(initialSearchParams.pageNumber),
            pageSize: new FormControl(initialSearchParams.pageSize),

            categories: new FormControl(initialSearchParams.categories),
            areas: new FormControl(initialSearchParams.areas),
            postcode: new FormControl(initialSearchParams.postcode),
            distance: new FormControl(initialSearchParams.distance)
        });

        return new DirectorySearchForm(formGroup, initialSearchParams, emptySearchParams);
    }

    public get instance(): FormGroup { return this.formInstance; }

    public get searchText(): AbstractControl { return this.getFormControl("searchText"); }
    public get sortOption(): AbstractControl { return this.getFormControl("sortOption"); }
    public get pageNumber(): AbstractControl { return this.getFormControl("pageNumber"); }
    public get pageSize(): AbstractControl { return this.getFormControl("pageSize"); }

    public get categories(): AbstractControl { return this.getFormControl("categories"); }
    public get areas(): AbstractControl { return this.getFormControl("areas"); }
    public get postcode(): AbstractControl { return this.getFormControl("postcode"); }
    public get distance(): AbstractControl { return this.getFormControl("distance"); }

    protected constructor(
        formInstance: FormGroup,
        initialSearchParams: DirectorySearchParametersModel,
        private emptySearchParams: DirectorySearchParametersModel
    ) {
        super(formInstance, initialSearchParams);
    }

    protected bindOnChangeSubscription(): Observable<DirectorySearchParametersModel> {
        return merge(
            this.searchText.valueChanges.pipe(map((searchText: string) => ({
                searchText: searchText,
                pageNumber: 1
            }))),
            this.sortOption.valueChanges.pipe(map((sortOption: string) => ({
                searchText: this.initialFormState.searchText,
                sortOption: sortOption,
                pageNumber: 1
            }))),
            this.pageNumber.valueChanges.pipe(map((pageNumber: number) => ({
                searchText: this.initialFormState.searchText,
                pageNumber: pageNumber
            }))),
            this.pageSize.valueChanges.pipe(map((pageSize: number) => ({
                searchText: this.initialFormState.searchText,
                pageNumber: 1,
                pageSize: pageSize
            }))),
            this.categories.valueChanges.pipe(map((categories: Array<string>) => ({
                searchText: this.initialFormState.searchText,
                pageNumber: 1,
                categories: categories
            }))),
            this.areas.valueChanges.pipe(map((areas: Array<string>) => ({
                searchText: this.initialFormState.searchText,
                pageNumber: 1,
                areas: areas
            }))),
            this.postcode.valueChanges.pipe(map((postcode: string) => ({
                searchText: this.initialFormState.searchText,
                pageNumber: 1,
                postcode: postcode
            }))),
            this.distance.valueChanges.pipe(map((distance: string) => ({
                searchText: this.initialFormState.searchText,
                pageNumber: 1,
                distance: distance
            })))
        ).pipe(
            map(partialModel => this.getFormModel(partialModel))
        );
    }

    protected getFormModel(partialFormModel: any = {}): DirectorySearchParametersModel {
        return _merge(new DirectorySearchParametersModel(), super.getFormModel(partialFormModel));
    }

    public reset(): void {
        this.formInstance.patchValue(this.emptySearchParams, { emitEvent: false });
    }
}
